// Shared soft-wrap fold for both v0.2 (legacy) and v0.3 (canonical) parser
// paths. When a line ends inside an unterminated `"` (odd count of
// unescaped quotes), join the following line(s) into it until the quote
// closes. This is the gut fix for the v2 DMS bug where the model emitted
// multi-line quoted descriptions and the parser silently truncated each
// value to its first line.
//
// Headings (`## Foo`, `### Bar`, `#### Steps`) and structural bullets
// without quotes are untouched — the fold only fires inside an open
// quoted string, so the section / entity splitters keep working.

export function foldSoftWrappedQuotes(body: string): string {
  const lines = body.split("\n");
  const out: string[] = [];
  let i = 0;
  while (i < lines.length) {
    const first = lines[i] ?? "";
    let totalQuotes = countUnescapedQuotes(first);
    if (totalQuotes % 2 === 0) {
      out.push(first);
      i += 1;
      continue;
    }
    let folded = first;
    let j = i + 1;
    while (j < lines.length && totalQuotes % 2 === 1) {
      const next = lines[j] ?? "";
      folded = `${folded.replace(/\s+$/, "")} ${next.replace(/^\s+/, "")}`;
      totalQuotes += countUnescapedQuotes(next);
      j += 1;
    }
    out.push(folded);
    i = j;
  }
  return out.join("\n");
}

function countUnescapedQuotes(line: string): number {
  let count = 0;
  for (let i = 0; i < line.length; i += 1) {
    if (line[i] === '"' && line[i - 1] !== "\\") count += 1;
  }
  return count;
}
